import { render } from "./CelestialEntities.vue?vue&type=template&id=e31d712e&scoped=true"
import script from "./CelestialEntities.vue?vue&type=script&lang=js"
export * from "./CelestialEntities.vue?vue&type=script&lang=js"

import "./CelestialEntities.vue?vue&type=style&index=0&id=e31d712e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e31d712e"]])

export default __exports__